/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProductHistoryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ProductHistoryQuery = { __typename?: 'Query' } & {
  productHistory: Types.Maybe<
    Array<
      { __typename?: 'ProductHistory' } & Pick<
        Types.ProductHistory,
        'productId' | 'viewedAt'
      >
    >
  >;
};

export const ProductHistoryDocument = /*#__PURE__*/ `
    query ProductHistory {
  productHistory {
    productId
    viewedAt
  }
}
    `;

export function useProductHistoryQuery(
  options?: Omit<Urql.UseQueryArgs<ProductHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ProductHistoryQuery, ProductHistoryQueryVariables>({
    query: ProductHistoryDocument,
    ...options,
  });
}
